import { emailAddressRegex } from '~lib/shared/helpers/regex';
export const sanitiseEmailAddress = (value) => value.replace(/[^a-zA-Z0-9_/\-+@.]/g, '');
export const isValidLookingEmailAddress = (value) => {
    if (typeof value !== 'string')
        return false;
    const safeInput = sanitiseEmailAddress(value);
    return Boolean(emailAddressRegex.exec(safeInput));
};
